import React, { Component } from 'react';

import CheckboxSection from "./CheckboxSection";
import ConfiguracionAvanzadaActiveDirectory from "./ConfiguracionAvanzadaActiveDirectory";

const ModeActiveDirectory = (props) => {
    return (
        <div className="row">
            <div>

                <CheckboxSection message="Vincular Perfiles con Grupo de Windows"                   
                    isChecked={props.vincularGrupoWindows} />

                {props.vincularGrupoWindows ?
                    (<div className="left-separator-xs"><CheckboxSection message="Permitir el alta del usuario en GyF de forma automática"
                        isChecked={props.altaAutomatica} /> </div>) : (<div></div>)}

                {props.vincularGrupoWindows ?
                    <p>La administración de sesiones por medio de Active Directory permite por defecto que el usuario logueado en Windows ingrese a los sistemas “G&F” con sus credenciales del sistema operativo. Puede modificar la forma de iniciar sesión en la Configuración avanzada."</p>
                    : null}

                <ConfiguracionAvanzadaActiveDirectory
                    soloUsuarioLoggeado={props.soloUsuarioLoggeado}
                    solicitarContrasenia={props.solicitarContrasenia}/>                
            </div>
        </div>
    );
};

export default ModeActiveDirectory;


